/* Shraddha Lite v0.1 - browser-only same-origin Shopify catalog/content retrieval. */
(function () {
  "use strict";
  var root = document.getElementById("sp-shraddha-lite");
  if (!root || root.dataset.mounted === "true") return;
  root.dataset.mounted = "true";
  var launch = root.querySelector("[data-sp-launch]");
  var panel = root.querySelector("[data-sp-panel]");
  var close = root.querySelector("[data-sp-close]");
  var clear = root.querySelector("[data-sp-clear]");
  var form = root.querySelector("[data-sp-form]");
  var input = root.querySelector("[data-sp-input]");
  var results = root.querySelector("[data-sp-results]");
  var suggestions = root.querySelector("[data-sp-suggestions]");
  var status = root.querySelector("[data-sp-status]");
  var localeSelect = root.querySelector("[data-sp-language]");
  var version = 0, pending = null, busy = false;
  var lang = root.dataset.locale === "hi" ? "hi" : "en";
  var currency = /^[A-Z]{3}$/.test(root.dataset.currency || "") ? root.dataset.currency : "INR";
  var locales = {
    "en": {
      "greeting": "Namaste! 🙏 I'm Shraddha, your puja companion. Looking for puja essentials or a helpful guide? Tell me what you have in mind.",
      "help": "",
      "placeholder": "What can I help you find?",
      "send": "Send",
      "empty": "What would you like to explore?",
      "loading": "Just a moment, I'm looking...",
      "found": "Here are a few things you might like:",
      "none": "I didn't see a close match yet. Have a look at the wider selection on Sabpuja.",
      "error": "The search is taking a little longer. You can explore Sabpuja directly in the meantime.",
      "search": "Explore more on Sabpuja",
      "account": "For updates on your order, your Sabpuja account is the best place to start. Our team is here if you need a hand.",
      "accountAction": "Go to my account",
      "support": "Need a hand with delivery, returns or something else? Our Sabpuja support team would be happy to help.",
      "supportAction": "Contact Sabpuja",
      "open": "Chat with Shraddha",
      "close": "Close chat",
      "clear": "Start again",
      "product": "Puja essentials",
      "collection": "Collection",
      "page": "Guide & information",
      "article": "Article",
      "price": "Price",
      "starterLabel": "Popular questions",
      "suggestions": [
        ["Which puja kits can I explore?","puja kit"],
        ["How do I do daily puja?","daily puja vidhi"],
        ["What's available for Diwali?","diwali"],
        ["How do I contact support?","contact support"]

      ],
      "me": "You",
      "assistant": "Shraddha",
      "availability": "Check the product page for the latest availability."
    },
    "hi": {
      "greeting": "नमस्ते! 🙏 मैं श्रद्धा हूँ, आपकी पूजा में साथी। पूजा की सामग्री या कोई उपयोगी गाइड ढूँढ रहे हैं? बताइए, आज किस चीज़ में मदद करूँ?",
      "help": "",
      "placeholder": "आप क्या ढूँढ रहे हैं?",
      "send": "भेजें",
      "empty": "आप क्या देखना चाहेंगे?",
      "loading": "एक पल, मैं देख रही हूँ...",
      "found": "आपके लिए ये विकल्प मिले हैं:",
      "none": "अभी कोई सटीक मिलान नहीं दिखा। सबपूजा पर और विकल्प देखिए।",
      "error": "खोज में थोड़ी देर हो रही है। इस बीच सबपूजा पर सीधे देख सकते हैं।",
      "search": "सबपूजा पर और देखें",
      "account": "ऑर्डर की जानकारी के लिए अपने सबपूजा अकाउंट में जाएँ। ज़रूरत हो तो हमारी टीम मदद के लिए मौजूद है।",
      "accountAction": "मेरा अकाउंट",
      "support": "डिलीवरी, रिटर्न या किसी और सवाल में मदद चाहिए? हमारी टीम से संपर्क करें।",
      "supportAction": "संपर्क करें",
      "open": "श्रद्धा से चैट करें",
      "close": "चैट बंद करें",
      "clear": "फिर से शुरू करें",
      "product": "पूजा सामग्री",
      "collection": "कलेक्शन",
      "page": "गाइड व जानकारी",
      "article": "लेख",
      "price": "कीमत",
      "starterLabel": "अक्सर पूछे जाने वाले सवाल",
      "suggestions": [
        ["कौन-सी पूजा किट देखें?","puja kit"],
        ["दैनिक पूजा कैसे करें?","daily puja vidhi"],
        ["दिवाली के लिए क्या है?","diwali"],
        ["सहायता कैसे मिलेगी?","contact support"]

      ],
      "me": "आप",
      "assistant": "श्रद्धा",
      "availability": "उपलब्धता की ताज़ा जानकारी प्रोडक्ट पेज पर देखें।"
    },
    "hinglish": {
      "greeting": "Namaste! 🙏 Main Shraddha hoon, aapki puja saathi. Puja ka samaan ya koi helpful guide dhoondh rahe hain? Batayein, aaj kya dekhna hai?",
      "help": "",
      "placeholder": "Kya dhoondhna hai?",
      "send": "Send",
      "empty": "Aap kya explore karna chahenge?",
      "loading": "Ek pal, main dekh rahi hoon...",
      "found": "Aapke liye kuch options mile hain:",
      "none": "Abhi exact match nahi dikha. Sabpuja par aur options explore kar sakte hain.",
      "error": "Search mein thoda waqt lag raha hai. Tab tak Sabpuja par directly browse kar sakte hain.",
      "search": "Sabpuja par aur dekhein",
      "account": "Order ki update ke liye apne Sabpuja account mein jaayein. Zaroorat ho toh humari team help kar degi.",
      "accountAction": "Mera account",
      "support": "Delivery, returns ya kisi aur cheez mein help chahiye? Sabpuja support team se baat karein.",
      "supportAction": "Support se baat karein",
      "open": "Shraddha se chat karein",
      "close": "Chat band karein",
      "clear": "Phir se shuru karein",
      "product": "Puja essentials",
      "collection": "Collection",
      "page": "Guide & info",
      "article": "Article",
      "price": "Price",
      "starterLabel": "Kuch sawal jo aap pooch sakte hain",
      "suggestions": [
        ["Kaunsi puja kit dekhein?","puja kit"],
        ["Daily puja kaise karein?","daily puja vidhi"],
        ["Diwali ke liye kya hai?","diwali"],
        ["Support se kaise baat karein?","contact support"]

      ],
      "me": "Aap",
      "assistant": "Shraddha",
      "availability": "Latest availability product page par check karein."
    }
  };
  function t() { return locales[lang]; }
  function el(tag, className, value) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined && value !== null) node.textContent = String(value);
    return node;
  }
  function validUrl(value, kind) {
    if (typeof value !== "string" || !value) return null;
    try {
      var url = new URL(value, location.origin);
      if (url.origin !== location.origin || !/^https?:$/.test(url.protocol)) return null;
      var path = url.pathname;
      var suffixes = {"product":"/products/","collection":"/collections/","page":"/pages/","article":"/blogs/"};
      if (kind && suffixes[kind] && !path.includes(suffixes[kind])) return null;
      return url.pathname + url.search;
    } catch (_) { return null; }
  }
  function storeRoot() {
    var candidate = root.dataset.root || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    if (typeof candidate !== "string" || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?)?\/?$/i.test(candidate)) return "/";
    return candidate.endsWith("/") ? candidate : candidate + "/";
  }
  function searchUrl(q, overrideRoot) {
    var params = new URLSearchParams();
    params.set("q", q);
    params.set("resources[type]", "product,collection,page,article");
    params.set("resources[limit]", "5");
    params.set("resources[options][unavailable_products]", "hide");
    return (overrideRoot || storeRoot()) + "search/suggest.json?" + params.toString();
  }
  function searchPage(q) {
    return storeRoot() + "search?q=" + encodeURIComponent(q.slice(0,120));
  }
  function isPrivate(q) {
    return /\b(my|mera|meri|mere|mine|track|tracking)\s+(order|orders|parcel|package|shipment)\b|\b(order status|order tracking|refund status|account password|otp|password)\b|मेरा ऑर्डर|मेरी ऑर्डर|ऑर्डर कहाँ/i.test(q);
  }
  function isSupport(q) {
    return /\b(contact|support|customer care|complaint|helpdesk|customer service)\b|संपर्क|सहायता|कस्टमर केयर/i.test(q);
  }
  function searchTerm(value) {
    var q = value.replace(/[^\p{L}\p{M}\p{N}\s'-]/gu, " ").replace(/\s+/g, " ").trim().slice(0,120);
    q = q.replace(/^(can you|could you|please|i want to|i need|show me|find me|search for|help me find|where can i buy|tell me about)\s+/i, "");
    /* Search-keyword translation only, not religious instruction or invented claims. */
    [["दीपावली","diwali"],["दिवाली","diwali"],["नवरात्रि","navratri"],["दैनिक","daily"],["पूजा","puja"],["पुजा","puja"],["विधि","vidhi"],["सामग्री","samagri"],["लक्ष्मी","lakshmi"],["गणेश","ganesh"],["शिव","shiv"],["दुर्गा","durga"],["किट","kit"]].forEach(function(pair){q = q.split(pair[0]).join(pair[1]);});
    return q || value.slice(0,120);
  }
  function setBusy(value) {
    busy = value;
    form.querySelector("button[type=submit]").disabled = value;
    input.disabled = value;
    status.textContent = value ? t().loading : "";
  }
  function addMessage(role, text) {
    var wrapper = el("div", "sp-shraddha__message sp-shraddha__message--" + role);
    var label = el("span", "sp-shraddha__message-label", role === "user" ? t().me : t().assistant);
    var body = el("div", "sp-shraddha__message-body", text);
    wrapper.append(label, body);
    results.appendChild(wrapper);
    results.scrollTop = results.scrollHeight;
    return wrapper;
  }
  function safeImage(url) {
    if (typeof url !== "string" || !url) return null;
    try { var u = new URL(url, location.origin);
      if (u.protocol !== "https:" || (u.hostname !== "cdn.shopify.com" && u.origin !== location.origin)) return null;
      return u.href;
    } catch (_) { return null; }
  }
  function addResultCards(items) {
    var list = el("div", "sp-shraddha__cards");
    var labels = t();
    for (var i=0; i<items.length; i++) {
      var item = items[i], link = validUrl(item.url, item.kind);
      if (!link) continue;
      var a = el("a", "sp-shraddha__card");
      a.href = link;
      if (item.kind === "product") {
        var src = safeImage(item.image || (item.featured_image && item.featured_image.url));
        if (src) { var img = el("img", "sp-shraddha__card-image");img.src=src;img.alt="";img.loading="lazy";a.append(img); }
      }
      var group = el("span", "sp-shraddha__card-content");
      group.append(el("span", "sp-shraddha__card-type", labels[item.kind] || labels.page));
      group.append(el("strong", "sp-shraddha__card-title", item.title || ""));
      if (item.kind === "product") {
        var price = typeof item.price === "string" || typeof item.price === "number" ? Number(item.price) : NaN;
        if (Number.isFinite(price) && price >= 0) {
          try {group.append(el("span","sp-shraddha__card-price",new Intl.NumberFormat(lang==="hi"?"hi-IN":"en-IN",{style:"currency",currency:currency,maximumFractionDigits:2}).format(price)));} catch(_){}
        }
      }
      a.append(group, el("span","sp-shraddha__card-arrow","↗"));
      list.append(a);
    }
    if (list.childElementCount) results.append(list);
    return list.childElementCount;
  }
  function addAction(label,url) {
    var href = validUrl(url);
    if (!href) return;
    var a = el("a","sp-shraddha__action",label + " ↗");
    a.href = href;results.append(a);
  }
  function closeChat() {
    root.dataset.open = "false";
    launch.setAttribute("aria-expanded","false");
    panel.hidden = true;
    launch.focus();
  }
  function openChat() {
    root.dataset.open = "true";
    launch.setAttribute("aria-expanded","true");
    panel.hidden = false;
    input.focus();
  }
  function reset() {
    version++;
    if (pending) { pending.abort();pending=null; }
    setBusy(false);
    results.replaceChildren();
    suggestions.replaceChildren();
    addMessage("bot", t().greeting);
    /* Starter questions live inside the chat history, not pinned to the composer. */
    results.appendChild(suggestions);
    suggestions.hidden = false;
    suggestions.appendChild(el("p","sp-shraddha__suggestions-label",t().starterLabel));
    t().suggestions.forEach(function(item) {
      var button = el("button","sp-shraddha__chip");
      button.type = "button";
      button.append(el("span","sp-shraddha__chip-text",item[0]));
      var arrow = el("span","sp-shraddha__chip-arrow","↗");
      arrow.setAttribute("aria-hidden","true");
      button.append(arrow);
      button.addEventListener("click",function(){search(item[0],item[1]);});
      suggestions.append(button);
    });
    results.scrollTop=0;
    status.textContent = "";
    input.placeholder = t().placeholder;
    input.setAttribute("aria-label",t().placeholder);
    var sendButton = form.querySelector("button[type=submit]");
    sendButton.setAttribute("aria-label",t().send);
    sendButton.title = t().send;
    launch.setAttribute("aria-label",t().open);
    close.setAttribute("aria-label",t().close);
    clear.setAttribute("aria-label",t().clear);
  }
  async function search(query, lookupTerm) {
    var original = String(query || "").trim().slice(0,120);
    if (!original || busy) {if (!original) status.textContent = t().empty;return;}
    addMessage("user",original);
    suggestions.replaceChildren();
    suggestions.hidden = true;
    if (isPrivate(original)) {
      addMessage("bot",t().account);
      addAction(t().accountAction,storeRoot()+"account");
      return;
    }
    if (isSupport(original)) {
      addMessage("bot",t().support);
      addAction(t().supportAction,storeRoot()+"pages/contact-us");
      return;
    }
    var searched = searchTerm(lookupTerm || original);
    var id = ++version;
    var controller = new AbortController();pending = controller;setBusy(true);
    var timeout = setTimeout(function(){controller.abort();},7000);
    try {
      var options = {credentials:"same-origin",headers:{"Accept":"application/json"},signal:controller.signal};
      var response = await fetch(searchUrl(searched),options);
      /* Shopify may reject predictive search on an unsupported translated route (417). */
      if (response.status === 417 && storeRoot() !== "/") response = await fetch(searchUrl(searched,"/"),options);
      if (!response.ok) throw new Error("Search failed");
      var body = await response.json();
      if (id !== version) return;
      var r = body && body.resources && body.resources.results;
      if (!r || typeof r !== "object") throw new Error("Unexpected search response");
      var items = [];
      ["products","collections","pages","articles"].forEach(function(key) {
        var kind = key.slice(0,-1);
        (Array.isArray(r[key])?r[key]:[]).slice(0,4).forEach(function(row) {
          if (!row || typeof row.title !== "string") return;
          items.push(Object.assign({kind:kind},row));
        });
      });
      if (!items.length) addMessage("bot",t().none);
      else {
        addMessage("bot",t().found);
        if (!addResultCards(items)) addMessage("bot",t().none);
      }
      addAction(t().search,searchPage(searched));
    } catch(error) {
      if (id === version) { addMessage("bot",t().error);addAction(t().search,searchPage(searched)); }
    } finally {
      clearTimeout(timeout);
      if (id === version) {pending=null;setBusy(false);}
    }
  }
  launch.addEventListener("click",function(){root.dataset.open==="true"?closeChat():openChat();});
  close.addEventListener("click",closeChat);
  clear.addEventListener("click",reset);
  form.addEventListener("submit",function(e){e.preventDefault();var query=input.value;input.value="";search(query);});
  localeSelect.addEventListener("change",function(){lang = locales[localeSelect.value]?localeSelect.value:"en";reset();});
  document.addEventListener("keydown",function(e){if(e.key==="Escape" && root.dataset.open==="true") closeChat();});
  reset();
})();
